import React from "react";
import { Card, Typography, QRCode, Button, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const AppDownloadPage: React.FC = () => {
  const navigate = useNavigate();

  // Replace this with your real App Store URL
  //Repalce with hairplane ios link
  const appStoreUrl = "https://apps.apple.com/app/your-app-id";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f9f9f9",
        padding: 24,
      }}
    >
      <Card
        style={{
          width: "80%",
          maxWidth: 800,
          textAlign: "center",
          borderRadius: 16,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          padding: "32px 24px",
        }}
      >
        <Title level={3}>Install Our App!</Title>
        <Text type="secondary">
          Scan the QR code or tap the button below to download the Hairplane iOS app.
        </Text>

        <Row
          justify="center"
          align="middle"
          gutter={[32, 32]}
          style={{ marginTop: 40, marginBottom: 24 }}
        >
          <Col xs={24} sm={12} md={10}>
            <img
              src="/logo192.png"
              alt="Hairplane Logo"
              style={{
                width: 160,
                height: 160,
                objectFit: "contain",
                display: "block",
                margin: "0 auto",
              }}
            />
          </Col>

          <Col xs={24} sm={12} md={10}>
            <QRCode
              value={appStoreUrl}
              size={180}
              style={{ margin: "0 auto" }}
            />
            <Button
              type="primary"
              size="large"
              style={{
                marginTop: 24,
                borderRadius: 8,
                padding: "0 24px",
              }}
              onClick={() => window.open(appStoreUrl, "_blank")}
            >
              Download on the App Store
            </Button>
          </Col>
        </Row>

        <Button
          onClick={() => navigate("/")}
          style={{
            marginTop: 8,
            borderRadius: 8,
          }}
        >
          Back to Home
        </Button>
      </Card>
    </div>
  );
};

export default AppDownloadPage;
